/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback, useState } from 'react';

export const useModalState = (
	defaultOpen = false,
): {
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
} => {
	const [isOpen, setIsOpen] = useState(defaultOpen);
	const onClose = useCallback((): void => setIsOpen(false), [setIsOpen]);
	const onOpen = useCallback((): void => setIsOpen(true), [setIsOpen]);
	return { isOpen, onClose, onOpen };
};
